import {
  RATE_LIST_REPORT_GO_BUTTON_ACTION,
  RATE_LIST_REPORT_GO_BUTTON_SUCCESS,
  RATE_LIST_REPORT_API_ERROR_ACTION,
} from "./actionType";

export const Rate_List_Report_GoButton_Action = (config = {}) => ({
  type: RATE_LIST_REPORT_GO_BUTTON_ACTION,
  config,
});

export const Rate_List_Report_GoButton_Success = (resp) => ({
  type: RATE_LIST_REPORT_GO_BUTTON_SUCCESS,
  payload: resp,
});

export const Rate_List_Report_ApiErrorAction = () => ({
  type: RATE_LIST_REPORT_API_ERROR_ACTION,
});
